import PropTypes from 'prop-types';
import DateTimeInput from './DateTimeInput';
import { useField, useFormikContext } from 'formik';

export default function DateTimeInputField({ label, ...props }) {
  const [field, meta] = useField(props);
  const { submitCount } = useFormikContext();

  return (
    <DateTimeInput
      isValid={(!meta.touched && !submitCount) || !meta.error}
      error={meta.error}
      label={label}
      {...props}
      {...field}
    />
  );
}

DateTimeInputField.propTypes = {
  label: PropTypes.string,
};
